import { createTrack } from './analytics/track'
import { trackProviderClickout } from './analytics/provider-clickout'
import type { ApiOptions } from './analytics/types'

export default defineNuxtPlugin({
  name: 'analytics',
  dependsOn: ['language', 'features', 'cookie'],
  async setup({ $lang }) {
    const logger = useLogger('plugin:analytics')
    try {
      const config = useRuntimeConfig()
      const { analyticsEventsUrl, name, version, redirectUrl } = config.public

      const apiOptions: ApiOptions = {
        server: import.meta.client ? analyticsEventsUrl : config.analyticsEventsServerUrl,
        lang: $lang as string,
        languageTag: import.meta.client
          ? navigator.language
          : useRequestEvent()?.node.req.headers['accept-language']?.split(',')[0] || 'N/A',
        clientVersion: version,
        clientName: __IS_MOBILE_APP__ ? 'imt' : name.replace('@gifsa/', ''),
        device: undefined,
        osVersion: undefined,
      }

      if (__IS_MOBILE_APP__) {
        apiOptions.device = 'mobileApp'
        try {
          const { Device } = await import('@capacitor/device')
          const [languageTag, deviceInfo] = await Promise.all([
            Device.getLanguageTag(),
            Device.getInfo(),
          ])
          if (languageTag.value) {
            apiOptions.languageTag = languageTag.value
          }
          if (deviceInfo.operatingSystem !== 'unknown') {
            apiOptions.osVersion = `${deviceInfo.operatingSystem}_${deviceInfo.osVersion}`
          }
        } catch (e) {
          logger.error(e, 'Unable to get device info for analytics')
        }
      }

      const track = createTrack(apiOptions)

      if (import.meta.client) {
        trackProviderClickout(redirectUrl, track)
      }

      return { provide: { track } }
    } catch (e) {
      logger.error(e)
      throw e
    }
  },
})
